import { useState, useCallback, useRef } from "react";
import { Listing } from "src/types/listing";
import { useAreaProInsights } from "./useAreaProInsights";

export const useAreaPro = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [insightsUrl, setInsightsUrl] = useState<string | null>(null);
  const requestIdRef = useRef(0);

  const { mutateAsync: getInsightsUrl, isPending: isLoading } = useAreaProInsights();

  const openAreaPro = useCallback(
    async (listing: Listing) => {
      const requestId = ++requestIdRef.current;
      setInsightsUrl(null);
      setIsOpen(true);

      try {
        const url = await getInsightsUrl(listing);
        if (requestId === requestIdRef.current) {
          setInsightsUrl(url);
        }
      } catch (error) {
        console.error("Failed to get AreaPro insights URL:", error);
      }
    },
    [getInsightsUrl]
  );

  const closeAreaPro = useCallback(() => {
    setIsOpen(false);
    setInsightsUrl(null);
  }, []);

  return {
    openAreaPro,
    closeAreaPro,
    isOpen,
    insightsUrl,
    isLoading,
  };
};
